<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<div class="img_containerf"><img alt="images" src="images/f0003-01.jpg"/>
</div>
<p class="half">GREAT WESTERN</p>
<p class="half1">0-6-2 TANK CLASSES</p>
<p class="half2">ABSORBED AND SWINDON DESIGNED CLASSES</p>
<a id="page_2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?42901ec6